import * as React from 'react';
import Section from 'core/components/Section/Section';
import classNames from 'classnames';
import StartBookingButton from 'booking/components/StartBookingButton';
import CtaFooterTopSwirl from 'assets/cta-top-swirl.inline.svg';
import CtaFooterMobileTopSwirl from 'assets/cta-top-swirl-mobile.inline.svg';
import * as styles from './CtaFooter.module.scss';

type CtaFooterProps = {
    noWhiteSpace?: boolean;
    mobileWhiteSpace?: boolean;
    title?: React.ReactNode;
    content?: React.ReactNode;
    locationId?: string;
    ctaText?: React.ReactNode;
    cta?: React.ReactNode;
    classes?: Partial<typeof styles>;
};

function CtaFooter({
    noWhiteSpace = false,
    mobileWhiteSpace = false,
    title,
    content,
    locationId,
    ctaText,
    cta,
    classes,
}: CtaFooterProps) {
    return (
        <>
            <Section
                classes={{
                    root: classNames(classes?.root, styles.root, {
                        [styles.rootWhiteSpace]: !noWhiteSpace,
                        [styles.mobileRootWhiteSpace]: mobileWhiteSpace,
                    }),
                    content: styles.content,
                }}
            >
                <div className={styles.topSwirl}>
                    <CtaFooterTopSwirl
                        role="none"
                        className={styles.desktopTopSwirl}
                    />
                    <CtaFooterMobileTopSwirl
                        role="none"
                        className={styles.mobileTopSwirl}
                    />
                </div>
                {title}
                {content}
                {!cta && (
                    <StartBookingButton
                        className={styles.button}
                        locationId={locationId}
                        variant="outlined"
                    >
                        <span>{ctaText || 'Book a visit'}</span>
                    </StartBookingButton>
                )}
                {cta}
            </Section>
        </>
    );
}

CtaFooter.defaultProps = {
    title: (
        <h3>
            Better care,
            <br />
            <em>Right when you need it</em>
        </h3>
    ),
};

export default CtaFooter;
